import { PRODUCER_STATUSES_CHANGED } from '../actions/types';

const initialState = {
    producerStatuses: {
        isPreMatchDown: false,
        isLiveDown: false,
    },
};

const feed = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case PRODUCER_STATUSES_CHANGED: {
            return { ...state, producerStatuses: { ...state.producerStatuses, ...payload } };
        }
        default:
            return state;
    }
};

export default feed;
